/*
 * Module for selecting the language of the content mapping to show on the screen
 */

define([
  "marionette",
  "backbone",
  "jquery",
  "messaging/messenger",
  "modules/contentsSplit/content/contentLanguage/contentLanguageView",
], function (Marionette, Backbone, $, Messenger, ContentLanguageView) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "contentLanguage";
      this.region = options.region;
      this.selectedSearchLocale = options.selectedSearchLocale;
    },
    show: function (content) {
      this.content = content;
      // If the locale selected on the search page was "All", then set it to the default instead
      if (this.selectedSearchLocale === 0) {
        this.selectedSearchLocale = Messenger.reqres.request("default:response:language");
      }
      this.languages = Messenger.reqres.request("kb:languages");
      this.model = new Backbone.Model({
        languages: this.languages,
        selectedLanguage: this.selectedSearchLocale,
      });

      this.view = new ContentLanguageView.contentLanguageView({ model: this.model });

      this.model.get("languages").onSynced(function () {
        this.content.onSynced(function () {
          this.content.urls().onSynced(function () {
            this._prepareLocales(this.content.urls());
          }, this);
        }, this);
      }, this);

      this.view.on(
        "change:language",
        function (languageId) {
          //fire an event that the language was changed
          Messenger.vent.trigger("content:language:changed", parseInt(languageId, 10));
        },
        this,
      );
      this.showRegion(this.view);
    },
    //divide locales into 'has Content' and 'no Content' list to be shown as a dropdown
    _prepareLocales: function (contentUrls) {
      this.model.hasContentLabel = $.t("languages.hasContentLabel");
      this.model.noContentLabel = $.t("languages.noContentLabel");
      const localesHasContent = [];
      const localesNoContent = [];
      this.languages.each(function (language) {
        const hasContent = contentUrls.some(function (contentUrl) {
          if (language.get("id") === contentUrl.get("languageId") && contentUrl.get("url") !== "") {
            return true;
          }
        }, this);
        if (hasContent) {
          localesHasContent.push({ localeId: language.get("id"), name: language.get("name") });
        } else {
          localesNoContent.push({ localeId: language.get("id"), name: language.get("name") });
        }
      }, this);
      this.model.localesHasContent = localesHasContent;
      this.model.localesNoContent = localesNoContent;
      this.view.render();
    },
  });
});
